import { OreButton, OreHeading, OreText, OreStack } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'
import { useUserData } from '@/User/ui/context'
import { homeTranslation } from '@/Home/ui/homeTranslation'
import { HttpMethod } from '@/Shared/domain'
import { axiosFetch } from '@/Shared/infrastructure'
import { bannerAnalytics } from '@/Shared/infrastructure/endpoints'
import { formTranslation } from '@/Shared/ui/sharedTranslation'
import SvgTopMenuLogo from '../../../Shared/ui/assets/top_menu_logo.svg'
import '../assets/styles.css'

const topMenuToolkitUrl =
    'https://edenredprowp.s3.dualstack.eu-west-1.amazonaws.com/wp-content/Toolkit%20materiales_Top%20Men%C3%BA_Edenred%20Espa%C3%B1a.zip?utm_source=oreneta_partners&utm_medium=toolkit&utm_campaign=top_menu'

const TopMenuBanner = (): JSX.Element | null => {
    const { t } = useTranslation()
    const { merchant } = useUserData()
    const isOctober = new Date().getMonth() === 9

    const handleDownload = (): void => {
        void axiosFetch(bannerAnalytics, HttpMethod.POST)
        window.open(topMenuToolkitUrl, '_blank', 'noopener,noreferrer')
    }

    if (!isOctober || merchant.isNursery) {
        return null
    }

    return (
        <div className='top-menu-banner'>
            <OreStack direction="row" space="xsmall" placeItems="center" placeContent="space-between">
                <OreStack direction="row" space="small" placeItems="center">
                    <OreStack>
                        <img src={SvgTopMenuLogo} alt="" />
                    </OreStack>
                    <OreStack space="xsmall" placeItems="normal" placeContent='start'>
                        <div className='top-menu-banner__text-content'>
                            <OreHeading as="h3" size="title-sm" tone='white'>
                                {t(homeTranslation.banner.topMenu.title)}
                            </OreHeading>
                            <OreText size="text-sm" tone='white'>
                                {t(homeTranslation.banner.topMenu.description)}
                            </OreText>
                        </div>
                    </OreStack>
                </OreStack>
                <OreStack>
                    <OreButton
                        category="danger"
                        onClick={handleDownload}>
                        {t(formTranslation.buttons.download)}
                    </OreButton>
                </OreStack>
            </OreStack>
        </div>
    )
}

export default TopMenuBanner
